import styled from 'styled-components';
import {btn} from '../button/btn/Btn.css';
import {BGImageCenter, getStaticImage, LIGHT_BLUE4, mobileMedia, scrollbar} from '../../globalVariables/GlobalVariables';
import {popUpTop, popTitle} from '../newPopup/topPopup/TopPopup.css';
import {Close} from '../close/Close.css';
import {popUpBody} from '../newPopup/mobilePopup/MobilePopup.css';
import {alignCenter, dFlex, flexColumn, justifyBetween, justifyCenter} from '../../globalVariables/GlobalFlex';
import {checkbox} from '../checkbox/Checkbox.css';
const plain = getStaticImage('app/plain.png');

export const wrapper = styled.div`
    ${popUpTop}{
        background-color: ${LIGHT_BLUE4};
        border-radius: 5px 5px 0 0;
        height: 120px;
    }
    ${Close}{
        height: 60px;
        width: 60px;
        background-size: 14px;
    }
    ${popTitle}{
        width: 0;
    }
    ${popUpBody}{
        width: 681px;
        height: 611px;
        ${mobileMedia}{
            width: 100%;
            height: 100%;
        }
    }
`;

export const main = styled.div`
    inset-block-start: 35px;
    height: 100%;
    width: 100%;
    ${dFlex};
    ${flexColumn};
    ${justifyCenter};    
    ${mobileMedia}{
        width: calc(100vw - 80px);
    }
`;
export const icon = styled.div`
    ${BGImageCenter(plain, 'contain')};
    position: absolute;
    inset-inline-end: 35px;
    bottom: -46%;
    height: 143%;
    width: 220px;
    ${mobileMedia}{
        display: none;
    }
`;
export const title = styled.div`
    font-size: 20px;
    font-weight: 800;
    ${mobileMedia}{
        font-size: 18px;
    }
`;
export const text = styled.div`
    font-size: 16px;
    font-weight: 800;
    ${mobileMedia}{
        font-size: 14px;
    }
`;
export const body = styled.div`
    padding-inline: 60px;
    ${scrollbar};
    height: calc(100% - 180px);
    ${mobileMedia}{
        padding-inline: 20px;
        height: calc(100% - 220px);
    }

`;
export const buttons = styled.div`
    ${dFlex};
    ${justifyBetween};
    position: relative;
    inset-block-start: 50px;
    gap: 5px;
    width: 100%;
    ${mobileMedia}{
        ${scrollbar};
        width: 100%;
    }
    ${btn}{
        ${p=>!p.theme.rtl&& 'font-size: 11px'};
        padding: 11px 30px;
        &:hover{
            transform: scale(0.9);
        }
        &.SUCCESS{
            background-image: none;
            font-size: 13px;
        }
    }
`;
export const btnIcon=styled.div<{$icon: string}>`
    height: 15px;
    width: 15px;
    margin-inline-end: 5px;
     ${p=>BGImageCenter(p.$icon)};
    &.LOADING, &.FAILED{
        background-image: none;
    }
    
`;
export const wrapCheckbox = styled.div`
    ${dFlex};
    ${alignCenter};
    position: relative;
    inset-block-start: 30px;
    padding-block: 30px;
    ${checkbox}{
        margin-inline: 10px;
    }
`;
